import { CommonTranslation } from "../pages/main/content/CommonTranslation";
import {TranslationFunction} from "../store/localization/TranslMessasge";


export class BooleanFormatter {
    static formatAsYesNo(value: boolean | undefined | null, t: TranslationFunction): string {
        if (value === undefined || value === null) {
            return '';
        } else {
            return value ? t(CommonTranslation.YES) : t(CommonTranslation.NO);
        }
    }
}
